import React from "react";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { images } from "../../constants";
import "./About.css";
import { AppWrap, MotionWrap } from "../../wrapper";

// import { urlFor, client } from "../../client";
import { useState } from "react";
import { useEffect } from "react";

const abouts = [
  {
    title: "STORE DESIGN AND SETUP",
    description:
      "Helping businesses set up their Shopify store, including designing, choosing themes, configuring settings, and setting up payment gateways..",
    imgUrl: images.shopifyAboutOne,
  },
  {
    title: "STORE DEVELOPMENT",
    description:
      "Crafting Seamless Shopping Experiences: Your Vision, Our Expertise – Shopify Store Development Perfected!",
    imgUrl: images.shopifyAboutTwo,
  },

  {
    title: "THEME CUSTOMIZATION",
    description:
      "Modifying existing Shopify themes to match specific design preferences or add custom functionality.",
    imgUrl: images.shopifyAboutThree,
  },
  {
    title: "APP INTEGRATION",
    description:
      "Integrating third-party apps or custom-developed apps to extend the functionality of the Shopify store.",
    imgUrl: images.shopifyAboutFour,
  },
];

const About = () => {
  // const [abouts, setAbouts] = useState([]);

  // useEffect(() => {
  //   const query = '*[_type=="abouts"]';

  //   client.fetch(query).then((data) => setAbouts(data));
  // }, []);
  return (
    <>
      <div className="about-section">
        <h2 className="head-text">
          About <span>Me</span>
        </h2>

        <div className="about-text">
          {" "}
          <p>
          Hey there! I'm Dejan Robi, your friendly neighborhood Shopify store designer and developer. 
          
          🛠️ With a passion for crafting unique online experiences, I specialize in bringing your e-commerce vision to life, one pixel at a time.
          I excel in crafting captivating and user-friendly online storefronts that seamlessly blend aesthetic appeal with functionality. From sleek modern designs to intricate customizations, I pride myself on bringing your vision to life. Whether you're a budding entrepreneur or a seasoned business owner, let's collaborate to turn your e-commerce dreams into reality. With Dejan Robi, your online success story begins here.
          </p>
        </div>

        <div className="app__profiles">
          {abouts.map((about, index) => (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: "tween" }}
              className="app__profile-item"
              key={index}
            >
              <img src={about.imgUrl} alt={about.title} />
              <h2 className="bold-text" style={{ marginTop: 20 }}>
                {about.title}
              </h2>
              <p className="p-text" style={{ marginTop: 10 }}>
                {about.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* <div className="about__buttons">
          <a download="" href={images.MyResume} class="button button--flex">
            Download CV{" "}
            <FaCloudDownloadAlt
              className="download-icon"
              style={{ fontSize: "25px", fontWeight: 700 }}
            />
          </a>
        </div> */}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
